// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"5cc3550d","258":"108dd15d","552":"5cc3550d"}[chunkId] + ".chunk.css";
};